import React from 'react'
import ProductComponent from "../AddProduct/ProductComponent/ProductComponent";
import {useParams} from "react-router-dom";
import Page from "../../Page/Page";

const UpdateProduct = () => {
    const { productId } = useParams();
    return (
        <Page>
            <ProductComponent action="update" productId={productId}/>
        </Page>
    )
}
export default UpdateProduct
